import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&q=80&w=1200`;

const GLASSWARE = U("photo-1636740599648-ae84f705fc2e");
const DROPPER = U("photo-1506368249639-73a05d6f6488");

const categories = [
  { name: "Skincare", desc: "Actives-led serums, moisturisers and more.", tags: "Serums · Creams · Masks", img: U("photo-1585945037805-5fd82c2e60b1") },
  { name: "Haircare", desc: "Scalp-first care from cleanse to shine.", tags: "Shampoos · Oils · Serums", img: U("photo-1562322140-8baeececf3df") },
  { name: "Personal Care", desc: "Daily essentials, elevated in feel and function.", tags: "Body Wash · Lotions · Soaps", img: U("photo-1619451427882-6aaaded0cc61") },
  { name: "Baby Care", desc: "Gentle, dermatologically mindful formulations.", tags: "Lotions · Balms · Washes", img: U("photo-1522771930-78848d9293e8") },
  { name: "Ayurveda", desc: "Classical and proprietary doctor-led formulations.", tags: "Oils · Lehyams · Churnas", img: U("photo-1492552085122-36706c238263") },
  { name: "Nutraceuticals", desc: "Efficacious, compliant functional nutrition.", tags: "Capsules · Gummies · Powders", img: U("photo-1584308666744-24d5c474f2ae") },
  { name: "Wellness", desc: "Sleep, stress and lifestyle support formats.", tags: "Aromatherapy oils · Massage oils · Wellness teas", img: U("photo-1521146250551-a5578dcc2e64") },
  { name: "Spa Products", desc: "Professional-grade rituals for spas and salons.", tags: "Massage Oils · Shampoo", img: U("photo-1519823551278-64ac92734fb1") },
  { name: "Hospitality", desc: "Signature amenity ranges for premium stays.", tags: "Personal care · Minis · Kits", img: U("photo-1552046122-03184de85e08") },
];

const CategoryCard = ({ name, desc, tags, img, index }) => (
  <div
    data-testid={`category-card-${name.toLowerCase().replace(/\s/g, "-")}`}
    className="group relative overflow-hidden flex flex-col justify-between bg-cream rounded-xl border border-navy/10 p-7 min-h-[220px]"
  >
    <img
      src={img}
      alt={name}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover opacity-0 scale-105 transition-opacity duration-500 group-hover:opacity-100 group-hover:scale-100"
      style={{ transitionProperty: "opacity, transform", transitionDuration: "600ms" }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/45 to-navy/15 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

    <div className="relative flex items-start justify-end">
      <ArrowUpRight
        size={18}
        strokeWidth={1.5}
        className="text-navy/0 -translate-x-1 translate-y-1 transition-all duration-500 group-hover:text-ivory group-hover:translate-x-0 group-hover:translate-y-0"
      />
    </div>

    <div className="relative">
      <h3 className="font-display text-xl sm:text-2xl text-navy transition-colors duration-500 group-hover:text-ivory">
        {name}
      </h3>
      <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-out group-hover:grid-rows-[1fr]">
        <div className="overflow-hidden">
          <p className="pt-3 text-[13px] leading-relaxed text-ivory/90">{desc}</p>
          <p className="pt-2 text-[11px] uppercase tracking-[0.18em] font-semibold text-ivory/60">{tags}</p>
        </div>
      </div>
    </div>
  </div>
);

export default function Categories() {
  return (
    <section id="categories" data-testid="categories-section" className="py-24 lg:py-32 bg-powder/50 border-t border-navy/10 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader overline="Featured Categories" title={<>Every category, <em className="italic font-medium">covered.</em></>} />
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.slice(0, 3).map((c, i) => <Reveal key={c.name} delay={i * 0.06}><CategoryCard {...c} index={i} /></Reveal>)}
          <Reveal delay={0.2} className="row-span-2 overflow-hidden rounded-xl hidden lg:block">
            <img src={GLASSWARE} alt="Decorative lab glassware" className="w-full h-full object-cover" />
          </Reveal>
          {categories.slice(3, 6).map((c, i) => <Reveal key={c.name} delay={i * 0.06}><CategoryCard {...c} index={i + 3} /></Reveal>)}
          <Reveal delay={0.1} className="overflow-hidden rounded-xl hidden lg:block">
            <img src={DROPPER} alt="Botanical nutraceutical still life" className="w-full h-full object-cover" />
          </Reveal>
          {categories.slice(6).map((c, i) => <Reveal key={c.name} delay={i * 0.06}><CategoryCard {...c} index={i + 6} /></Reveal>)}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 text-[12px] uppercase tracking-[0.2em] font-semibold text-navy/50">
            Hover a category to explore formats
          </p>
        </Reveal>
      </div>
    </section>
  );
}
